import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactAudioPlayer from 'react-audio-player';
import GetCurrentBrowser from '../utils/getcurrentbrowser'
import "../css/audioplayer.css";

class AudioPlayer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currenttrackindex: 0,
            isPlaying: false,
            currentbrowser: GetCurrentBrowser()
        };
        this.handleOnPlay = this.handleOnPlay.bind(this);
        this.handleOnPause = this.handleOnPause.bind(this);
        this.handleGoToNextTrack = this.handleGoToNextTrack.bind(this);
        this.handleGoToPrevTrack = this.handleGoToPrevTrack.bind(this);
        this.handleGoToNextTrackAutomatic = this.handleGoToNextTrackAutomatic.bind(this);
    }

    handleTrackList = (param) => (e) => {
        this.setState({
            currenttrackindex: param,
            isPlaying: true
        })
    }

    handleOnPlay() {
        this.setState({ isPlaying: true });
    }

    handleOnPause() {
        console.log('onpause');
        this.setState({ isPlaying: false });
    }

    handleGoToNextTrackAutomatic() {
        let nextTrackIndex = this.state.currenttrackindex < this.props.trakslist.length - 1 ? this.state.currenttrackindex + 1 : 0;
        this.setState({ currenttrackindex: nextTrackIndex, isPlaying: true });
    }

    handleGoToNextTrack() {
        let nextTrackIndex = this.state.currenttrackindex < this.props.trakslist.length - 1 ? this.state.currenttrackindex + 1 : 0;
        this.setState({ currenttrackindex: nextTrackIndex });
    }

    handleGoToPrevTrack() {
        let prevTrackIndex = this.state.currenttrackindex > 0 ? this.state.currenttrackindex - 1 : this.props.trakslist.length - 1;
        this.setState({ currenttrackindex: prevTrackIndex });
    }

    componentDidUpdate() {
        if (this.state.isPlaying)
            this.rap.audioEl.play();
    }

    render() {
        const currentTrack = this.props.trakslist[this.state.currenttrackindex];
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="row row-card rounded">
                            <div className="col-sm-4">
                                <picture>
                                    <source type="image/webp" srcset="/img/audioplayer/poster_bkg.webp" />
                                    <img src="/img/audioplayer/poster_bkg.jpg" loading="lazy" className="figure-img img-fluid rounded" alt="..." />
                                </picture>
                            </div>
                            <div className="col-sm-8 d-flex flex-column">
                                <div>
                                    {currentTrack.author &&
                                        <div className="trackauthor">{currentTrack.author}</div>
                                    }
                                    <div className="tracktitle">{currentTrack.title}</div>
                                    {currentTrack.albumname &&
                                        <div className="trackalbum"><i className="fas fa-dot-circle" style={{ opacity: ".7", marginRight: "5px" }}></i>{currentTrack.albumname}</div>
                                    }
                                </div>
                                <div className="row audioplayer-content mt-auto mb-3">
                                    <div className="col-10 pr-0">
                                        <ReactAudioPlayer className="audioplayer rounded-left" onEnded={this.handleGoToNextTrackAutomatic} ref={(element) => { this.rap = element; }} src={currentTrack.src} controls
                                            onPlay={this.handleOnPlay} onPause={this.handleOnPause} />
                                    </div>
                                    <div className="col-2 pl-0">
                                        <a className={"btn btn-player m-0 btn-player-" + this.state.currentbrowser.name} onClick={this.handleGoToPrevTrack} title="Prossimo brano"><i className="fas fa-angle-double-left"></i></a>
                                        <a className={"btn btn-player m-0 rounded-right btn-player-" + this.state.currentbrowser.name} onClick={this.handleGoToNextTrack} title="Brano precedente"><i className="fas fa-angle-double-right"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mt-2 z-depth-1">
                    <div className="col-12 px-0 rounded">
                        {this.props.trakslist.map((track, index) =>
                            <div className={index === this.state.currenttrackindex ? "row m-0 py-2 trackitem active" : "row  m-0  py-2 trackitem"} key={index} onClick={this.handleTrackList(index)}>
                                <div className="col-1 px-2">
                                    {index === this.state.currenttrackindex && this.state.isPlaying && <img className="img-fluid" src="/img/audioplayer/equalizer.gif" alt="equalizer icon" />}
                                </div>
                                <div className="col-9">
                                    <div>
                                        <span className="tracknumber">{index + 1}.</span>{track.title}
                                        {track.author &&
                                            <span className="trackauthor"> - {track.author}</span>
                                        }
                                    </div>
                                    <div>
                                        {track.albumname &&
                                            <span className="trackalbum">{track.albumname}</span>
                                        }
                                    </div>
                                </div>
                                <div className="col-2 px-2 text-right font-roboto">
                                    {track.duration}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

AudioPlayer.propTypes = {
    trakslist: PropTypes.arrayOf(Object)
};

export default AudioPlayer;


// WEBPACK FOOTER //
// ./src/components/AudioPlayer.js